export default "__VITE_ASSET__C5V35_6R__"